module.exports = __webpack_public_path__ + "img/ap-login.202f60f4.png";